import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../styles/Sidebar.module.scss';
import { useSelector } from 'react-redux';
import ContactsBlock from './ContactsBlock';
import NewProductsCarousel from './NewProductsCarousel';
import SidebarCategoryMenu from './SidebarCategoryMenu';
import { getCategoryTreeWithProducts } from '../../utils/categoryTree';

const Sidebar = () => {
  const { list } = useSelector(({ categories }) => categories);
  const { list: products } = useSelector(({ products }) => products);
  const { data: contacts } = useSelector((state) => state.contacts);
  const [isCompact, setIsCompact] = useState(false);
  const [catalogOpen, setCatalogOpen] = useState(true);
  const [contactsOpen, setContactsOpen] = useState(false);

  const catalogTree = useMemo(
    () => getCategoryTreeWithProducts(list, products, { onlyPublished: true }),
    [list, products]
  );

  useEffect(() => {
    const media = window.matchMedia('(max-width: 768px)');

    const updateMode = () => {
      const compact = media.matches;
      setIsCompact(compact);
      setCatalogOpen(true);
      setContactsOpen(false);
    };

    updateMode();
    media.addEventListener('change', updateMode);
    return () => media.removeEventListener('change', updateMode);
  }, []);

  return (
    <section className={`${styles.sidebar}${isCompact ? ` ${styles.sidebarCompact}` : ''}`}>
      <div className={`${styles.sidebarPanel} ${styles.catalogPanel}`}>
        {isCompact ? (
          <button
            type="button"
            className={`${styles.sectionToggle}${catalogOpen ? ` ${styles.sectionToggleOpen}` : ''}`}
            onClick={() => setCatalogOpen((prev) => !prev)}
            aria-expanded={catalogOpen}
          >
            <span className={styles.title}>КАТАЛОГ</span>
            <span className={styles.sectionChevron} aria-hidden="true" />
          </button>
        ) : (
          <div className={styles.title}>КАТАЛОГ</div>
        )}
        <div className={`${styles.sectionBody}${!isCompact || catalogOpen ? ` ${styles.sectionBodyOpen}` : ''}`}>
          <SidebarCategoryMenu tree={catalogTree} categories={list} />
        </div>
      </div>

      <div className={`${styles.sidebarPanel} ${styles.novinkiPanel}`}>
        <NewProductsCarousel />
      </div>

      {isCompact ? (
        <div className={`${styles.sidebarPanel} ${styles.contactsPanel}`}>
          <button
            type="button"
            className={`${styles.sectionToggle}${contactsOpen ? ` ${styles.sectionToggleOpen}` : ''}`}
            onClick={() => setContactsOpen((prev) => !prev)}
            aria-expanded={contactsOpen}
          >
            <span className={styles.contactsTitle}>КОНТАКТИ</span>
            <span className={styles.sectionChevron} aria-hidden="true" />
          </button>
          <div className={`${styles.sectionBody}${contactsOpen ? ` ${styles.sectionBodyOpen}` : ''}`}>
            <ContactsBlock contacts={contacts} hideHeader />
          </div>
        </div>
      ) : (
        <ContactsBlock contacts={contacts} />
      )}
    </section>
  );
};

export default Sidebar;
